export type IconDefinition = {
  id: string;
  label: string;
  svg: (mainColor: string) => string;
};

const normalizeColor = (value: string) => (/^#[0-9a-fA-F]{6}$/.test(value) ? value : "#1d5cab");

export const CANVAS_ICON_LIBRARY: IconDefinition[] = [
  {
    id: "star",
    label: "Star",
    svg: (mainColor) => `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><rect width="48" height="48" rx="12" fill="#FFF7ED"/><path d="M24 8l4.7 9.6 10.6 1.5-7.7 7.5 1.8 10.5L24 32.1l-9.4 5 1.8-10.5-7.7-7.5 10.6-1.5L24 8z" fill="${normalizeColor(mainColor)}"/></svg>`,
  },
  {
    id: "cloud",
    label: "Cloud",
    svg: (mainColor) => `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><rect width="48" height="48" rx="12" fill="#EFF6FF"/><path d="M17 34h18a8 8 0 0 0 .6-16A12 12 0 0 0 13 21.5 6.5 6.5 0 0 0 17 34z" fill="${normalizeColor(mainColor)}"/></svg>`,
  },
  {
    id: "rocket",
    label: "Rocket",
    svg: (mainColor) => `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><rect width="48" height="48" rx="12" fill="#F5F3FF"/><path d="M30 7c5 2 8 5 11 11-3 1-7 4-10 8l-9-9c4-3 7-7 8-10z" fill="${normalizeColor(mainColor)}"/><circle cx="31" cy="17" r="3" fill="#FFFFFF"/><path d="M18 20l10 10-8 4-6-6 4-8z" fill="#A78BFA"/><path d="M15 32l-5 6 7-3z" fill="#F97316"/></svg>`,
  },
  {
    id: "leaf",
    label: "Leaf",
    svg: (mainColor) => `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><rect width="48" height="48" rx="12" fill="#ECFDF5"/><path d="M38 9C20 10 10 20 11 36c16 1 27-9 27-27z" fill="${normalizeColor(mainColor)}"/><path d="M15 33c6-9 13-15 21-21" stroke="#FFFFFF" stroke-width="3" stroke-linecap="round"/></svg>`,
  },
  {
    id: "lightning",
    label: "Lightning",
    svg: (mainColor) => `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><rect width="48" height="48" rx="12" fill="#FEFCE8"/><path d="M27 5L12 27h11l-2 16 15-23H25z" fill="${normalizeColor(mainColor)}"/></svg>`,
  },
  {
    id: "camera",
    label: "Camera",
    svg: (mainColor) => `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><rect width="48" height="48" rx="12" fill="#F8FAFC"/><rect x="9" y="15" width="30" height="22" rx="5" fill="${normalizeColor(mainColor)}"/><path d="M17 15l3-5h8l3 5z" fill="#475569"/><circle cx="24" cy="26" r="7" fill="#CBD5E1"/><circle cx="24" cy="26" r="4" fill="#0F172A"/></svg>`,
  },
  {
    id: "heart",
    label: "Heart",
    svg: (mainColor) => `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><rect width="48" height="48" rx="12" fill="#FFF1F2"/><path d="M24 38S10 29 10 18.5C10 13.8 13.8 10 18.5 10c2.7 0 4.6 1.3 5.5 3 1-1.7 2.8-3 5.5-3 4.7 0 8.5 3.8 8.5 8.5C38 29 24 38 24 38z" fill="${normalizeColor(mainColor)}"/></svg>`,
  },
  {
    id: "compass",
    label: "Compass",
    svg: (mainColor) => `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><rect width="48" height="48" rx="12" fill="#F0FDFA"/><circle cx="24" cy="24" r="15" fill="${normalizeColor(mainColor)}"/><path d="M29 14l-3 13-10 7 3-13z" fill="#FFFFFF"/><circle cx="24" cy="24" r="2" fill="#0F766E"/></svg>`,
  },
  {
    id: "music-note",
    label: "Music Note",
    svg: (mainColor) => `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><rect width="48" height="48" rx="12" fill="#FDF2F8"/><path d="M30 9v22a6 6 0 1 1-4-5.7V14l-12 3v18a6 6 0 1 1-4-5.7V14z" fill="${normalizeColor(mainColor)}"/></svg>`,
  },
  {
    id: "shield",
    label: "Shield",
    svg: (mainColor) => `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><rect width="48" height="48" rx="12" fill="#EEF2FF"/><path d="M24 7l15 6v10c0 10-6.5 16.5-15 19-8.5-2.5-15-9-15-19V13z" fill="${normalizeColor(mainColor)}"/><path d="M17 24l5 5 10-11" fill="none" stroke="#FFFFFF" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  },
  {
    id: "planet",
    label: "Planet",
    svg: (mainColor) => `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><rect width="48" height="48" rx="12" fill="#FAF5FF"/><circle cx="24" cy="24" r="11" fill="${normalizeColor(mainColor)}"/><path d="M8 28c5 4 27 3 32-8" fill="none" stroke="#FBBF24" stroke-width="4" stroke-linecap="round"/><circle cx="19" cy="20" r="2" fill="#E9D5FF"/><circle cx="28" cy="27" r="3" fill="#7E22CE"/></svg>`,
  },
  {
    id: "gift",
    label: "Gift",
    svg: (mainColor) => `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><rect width="48" height="48" rx="12" fill="#FEF2F2"/><rect x="10" y="20" width="28" height="18" rx="3" fill="${normalizeColor(mainColor)}"/><rect x="22" y="20" width="4" height="18" fill="#FDE68A"/><rect x="8" y="15" width="32" height="7" rx="2" fill="#DC2626"/><path d="M24 15c-6-8-14-3-7 1M24 15c6-8 14-3 7 1" fill="none" stroke="#FDE68A" stroke-width="3" stroke-linecap="round"/></svg>`,
  },
  {
    id: "lock",
    label: "Lock",
    svg: (mainColor) => `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><rect width="48" height="48" rx="12" fill="#F1F5F9"/><rect x="12" y="21" width="24" height="18" rx="4" fill="${normalizeColor(mainColor)}"/><path d="M17 21v-5a7 7 0 0 1 14 0v5" fill="none" stroke="#64748B" stroke-width="4" stroke-linecap="round"/><circle cx="24" cy="29" r="2" fill="#FFFFFF"/></svg>`,
  },
  {
    id: "fire",
    label: "Fire",
    svg: (mainColor) => `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><rect width="48" height="48" rx="12" fill="#FFF7ED"/><path d="M25 42c8-2 12-7 12-14 0-8-6-12-9-20-2 6-8 9-8 15-3-2-4-5-4-8-4 5-6 9-6 15 0 7 6 12 15 12z" fill="${normalizeColor(mainColor)}"/><path d="M25 38c4-1 7-4 7-8 0-4-3-7-5-11-1 4-5 6-5 10-2-1-2-2-3-4-2 3-3 5-3 8 0 3 3 5 9 5z" fill="#FDE68A"/></svg>`,
  },
  {
    id: "book",
    label: "Book",
    svg: (mainColor) => `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><rect width="48" height="48" rx="12" fill="#EFF6FF"/><path d="M10 11h13a5 5 0 0 1 5 5v23a5 5 0 0 0-5-5H10z" fill="${normalizeColor(mainColor)}"/><path d="M38 11H25a5 5 0 0 0-5 5v23a5 5 0 0 1 5-5h13z" fill="#60A5FA"/><path d="M24 16v23" stroke="#FFFFFF" stroke-width="2"/></svg>`,
  },
  {
    id: "umbrella",
    label: "Umbrella",
    svg: (mainColor) => `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><rect width="48" height="48" rx="12" fill="#F0F9FF"/><path d="M8 25a16 16 0 0 1 32 0c-4-3-7-3-10 0-4-3-8-3-12 0-3-3-6-3-10 0z" fill="${normalizeColor(mainColor)}"/><path d="M24 25v9a5 5 0 0 0 10 0" fill="none" stroke="#075985" stroke-width="3" stroke-linecap="round"/></svg>`,
  },
  {
    id: "bell",
    label: "Bell",
    svg: (mainColor) => `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><rect width="48" height="48" rx="12" fill="#FEFCE8"/><path d="M35 31H13c3-4 3-8 3-13a8 8 0 0 1 16 0c0 5 0 9 3 13z" fill="${normalizeColor(mainColor)}"/><path d="M20 34a4 4 0 0 0 8 0z" fill="#A16207"/><path d="M24 8v3" stroke="#A16207" stroke-width="3" stroke-linecap="round"/></svg>`,
  },
  {
    id: "target",
    label: "Target",
    svg: (mainColor) => `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><rect width="48" height="48" rx="12" fill="#F8FAFC"/><circle cx="24" cy="24" r="16" fill="${normalizeColor(mainColor)}"/><circle cx="24" cy="24" r="11" fill="#FFFFFF"/><circle cx="24" cy="24" r="6" fill="${normalizeColor(mainColor)}"/><circle cx="24" cy="24" r="2" fill="#FFFFFF"/></svg>`,
  },
  {
    id: "coffee",
    label: "Coffee",
    svg: (mainColor) => `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><rect width="48" height="48" rx="12" fill="#FFFBEB"/><path d="M13 19h20v9a9 9 0 0 1-18 0z" fill="${normalizeColor(mainColor)}"/><path d="M33 22h2a4 4 0 0 1 0 8h-2" fill="none" stroke="${normalizeColor(mainColor)}" stroke-width="4"/><path d="M17 12v4M24 10v5M31 12v4" stroke="#D97706" stroke-width="3" stroke-linecap="round"/></svg>`,
  },
  {
    id: "diamond",
    label: "Diamond",
    svg: (mainColor) => `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><rect width="48" height="48" rx="12" fill="#ECFEFF"/><path d="M15 10h18l8 10-17 20L7 20z" fill="${normalizeColor(mainColor)}"/><path d="M7 20h34M15 10l9 30 9-30M15 10l-8 10M33 10l8 10" fill="none" stroke="#E0F2FE" stroke-width="2" stroke-linejoin="round"/></svg>`,
  },
];

export const getCanvasIconDefinition = (iconId: string): IconDefinition =>
  CANVAS_ICON_LIBRARY.find((icon) => icon.id === iconId) ?? CANVAS_ICON_LIBRARY[0]!;

export const buildIconDataUrl = (iconId: string, mainColor: string) => {
  const definition = getCanvasIconDefinition(iconId);
  const svg = definition.svg(mainColor);
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
};
